import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { setSection } from "../../../assignmentSlice";

const SentenceReorder = ({
  currentPage,
  currentIndex,
  pageList,
  section,
  setPageList,
  setIsIncorrectOverlayVisible,
}) => {
  const dispatch = useDispatch();

  const [sentences, setSentences] = useState(currentPage.data.question);

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // 목적지가 없으면 (드롭하지 않은 경우) 아무 작업도 하지 않음
    if (!destination) return;

    // 같은 위치에 드롭했을 경우 아무 작업도 하지 않음
    if (source.index === destination.index) return;

    // 리스트 항목 순서 변경
    const updatedSentences = Array.from(sentences);
    const [movedItem] = updatedSentences.splice(source.index, 1);
    updatedSentences.splice(destination.index, 0, movedItem);

    setSentences(updatedSentences);
  };

  const handleSubmit = () => {
    const bool = currentPage.data.answer.every(
      (sentence, index) => sentence === sentences[index]
    );

    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          data: {
            ...page.data,
            input: [...page.data.input, sentences],
          },
          isSubmitted: bool,
        };
      }
      return page;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    setIsIncorrectOverlayVisible(true);
    setTimeout(() => {
      setIsIncorrectOverlayVisible(false);
      console.log(currentPage);
    }, 600);
  };

  useEffect(() => {
    setSentences(currentPage.data.question);
  }, [currentIndex]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "80%",
        height: "100%",
      }}
    >
      <div
        style={{
          fontSize: "20px",
        }}
      >
        문맥상 주어진 문장 다음에 이어질 글의 순서를 맞춰보세요.
      </div>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          fontSize: "24px",
        }}
      >
        {currentPage.data.question_text}
      </div>
      <div>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="sentences-list">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                {sentences?.map((sentence, index) => (
                  <Draggable
                    key={sentence}
                    draggableId={sentence}
                    index={index}
                    isDragDisabled={currentPage.isSubmitted}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          marginBottom: "10px",
                          backgroundColor: currentPage.isSubmitted && "#F6F8FA",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          fontSize: "18px",
                          display: "flex",
                          alignItems: "stretch",
                          gap: "20px",
                        }}
                      >
                        {/* 드래그 핸들 (점 8개) */}
                        <div
                          {...provided.dragHandleProps}
                          style={{
                            backgroundColor: "#EBEBEB", // 핸들 전체 배경색
                            borderRadius: "5px", // 핸들 모서리를 둥글게
                            padding: "0px 10px", // 핸들 내부 패딩
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 5px)",
                              gap: "3px",
                            }}
                          >
                            {Array(8)
                              .fill(0)
                              .map((_, i) => (
                                <div
                                  key={i}
                                  style={{
                                    width: "5px",
                                    height: "5px",
                                    backgroundColor: "#ccc",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              ))}
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "10px 0px",
                            marginRight: "10px",
                          }}
                        >
                          {sentence}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <button
        style={{
          position: "absolute", // 부모(80% width) 안에서 절대 위치
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: "10px 35px",
          backgroundColor: currentPage.isSubmitted ? "#EBEBEB" : "#2D2D2D",
          color: currentPage.isSubmitted ? "#737373" : "white",
          border: "none",
          fontSize: "18px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={currentPage.isSubmitted ? null : () => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default SentenceReorder;
